import React, { useLayoutEffect } from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import StepNavigationAmount from '../../../MUI/StepNavigationAmount';
import StepsNavigation from '../../../StepsNavigation';
import { MAIN_BUTTON_WIDTH_KEYS } from '../../../MUI/MainButton';

const Navigation = ({
  setStepNavigationBox,
  isDeviceLgSize,
  handleOpenMobileSummary,
  totalPrice,
  goPrevious,
  saveCard,
  isNextValid,
  handleNext,
  isNextDisabled,
  payBtnAmount,
}) => {
  const { t } = useTranslation();

  useLayoutEffect(() => {
    setStepNavigationBox(() => (
      <>
        {isDeviceLgSize && (
        <Grid container spacing={2} alignItems="center" onClick={handleOpenMobileSummary}>
          <StepNavigationAmount amount={totalPrice} iconDown={false} isMobile={isDeviceLgSize} />
        </Grid>
        )}
        <StepsNavigation
          back={goPrevious}
          next={() => handleNext(saveCard)}
          isNextDisabled={isNextDisabled || !isNextValid}
          nextBtnBlock={(
            <>
              {t('pay')}
              {!!payBtnAmount && !isDeviceLgSize && (
              <>
                &nbsp;
                <b>{payBtnAmount}</b>
              </>
              )}
            </>
            )}
          width={MAIN_BUTTON_WIDTH_KEYS.EXTRA_LARGE}
        />
      </>
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isDeviceLgSize,
    isNextDisabled,
    isNextValid,
    payBtnAmount,
    setStepNavigationBox,
    t,
    totalPrice,
    handleNext,
  ]);

  return null;
};

Navigation.propTypes = {
  isDeviceLgSize: PropTypes.bool.isRequired,
  goPrevious: PropTypes.func.isRequired,
  handleOpenMobileSummary: PropTypes.func.isRequired,
  setStepNavigationBox: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  totalPrice: PropTypes.number.isRequired,
  isNextValid: PropTypes.bool.isRequired,
  isNextDisabled: PropTypes.bool.isRequired,
  saveCard: PropTypes.bool.isRequired,
  payBtnAmount: PropTypes.string.isRequired,
};

export default Navigation;
